import { Trans, useLingui } from '@lingui/react/macro';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { AppDispatch } from 'store/store';
import UDButton from 'ud-ui/components/button';
import { saveGameDetails } from 'modules/games/store/actions';
import { gameDetailsIsSavingSelector, gameEventsChangedSelector } from 'modules/games/store/selectors';
import { useGameDetails } from 'modules/games/ui/hooks/use-game-details';
import { useGameDetailsFetch } from 'modules/games/ui/hooks/use-game-details-fetch';
import { GameResultHeader } from '../game-result-header';
import MainStreamURL from '../game-result/components/MainStreamURL';
import TimestampUrls from '../game-result/components/timestampUrls';
import EventsList from './components/events-list';

interface IProps {
  gameId: number;
  championshipId: number;
}

function MomentsPage(props: IProps) {
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useLingui();

  const { gameId, championshipId } = props;
  useGameDetailsFetch(gameId, championshipId);

  const { isLoading, data } = useGameDetails();

  const eventsChanged = useSelector(gameEventsChangedSelector);
  const isDetailsSaving = useSelector(gameDetailsIsSavingSelector);

  const isSaveButtonDisabled = useMemo(() => {
    return !eventsChanged || isDetailsSaving;
  }, [eventsChanged, isDetailsSaving]);

  const handleSaveMomentsUrls = useCallback(() => {
    if (!data) return;
    if (!eventsChanged) return;
    if (isDetailsSaving) return;

    dispatch(saveGameDetails(data))
      .then(() => {
        toast.success(t`Сохранено`);
      })
      .catch(() => {
        toast.error(t`Не удалось сохранить игру`);
      });
  }, [data, dispatch, eventsChanged, isDetailsSaving, t]);

  return (
    <div className={'mb-4'}>
      <GameResultHeader isLoading={isLoading} game={data} />
      <MainStreamURL isLoading={isLoading} game={data} />
      <TimestampUrls isLoading={isLoading} game={data} />
      <div className="mt-9">
        <EventsList game={data} isLoading={isLoading} />
      </div>

      <div className="mt-4 flex justify-start">
        <UDButton variant={'primary'} disabled={isSaveButtonDisabled} loading={isDetailsSaving} onClick={handleSaveMomentsUrls}>
          <Trans>Сохранить и опубликовать</Trans>
        </UDButton>
      </div>
    </div>
  );
}

export default MomentsPage;
